import schema from '../../ReativarBeneficiario/Beneficiario/schema';

import { cloneObject } from '../../../../utils';

function reativacao(form) {
    const dadosForm = cloneObject(schema);

    dadosForm.dataReativacao.value = form.dataReativacao;
    dadosForm.carteirinha = form.numAssociado;
    dadosForm.novoPlano.value = form.novoPlano;
    dadosForm.tipoReativacao.value = form.incidencia;
    dadosForm.novosPlanos = form.novosPlanos;
    dadosForm.dependentes = form.dependentes;
    dadosForm.nomeCompleto = form.nomeAssociado;
    dadosForm.tipoAssociado = form.tipoAssociado;
    dadosForm.empresa = form.empresa;
    dadosForm.plano = form.plano;

    return dadosForm;
}

export { reativacao };
